import React from 'react';
import { ButtonUI, ButtonVAProps } from './Button.Presenter';

export const ButtonContainer = React.memo(function ButtonContainer(props: ButtonVAProps) {
  const children = props.children;
  return <ButtonUI {...props}>{children}</ButtonUI>;
});
